// RoleList.js
import { useState, useEffect } from "react";
import List from "../../../common/list";
import { TextInput } from "../../../common/fields";
import { Button } from "primereact/button";
import useRecipientSelection from "./useRecipientSelection";

const UserList = ({
  users = [],
  totalCount = 0,
  query,
  setQuery,
  fetchUsers,
  selectedUsers,
  setSelectedUsers,
  preSelectedIds = [],
  onSave,
  onCancel,
}) => {
  // Starts with the search the dialog's list was last filtered by.
  const [searchTerm, setSearchTerm] = useState(query?.namePattern || "");

  // The search runs on the server: namePattern matches first name, last name
  // or email, and the list shows the result as is. Re-filtering it here by
  // name only hid every email match (E2E11).

  const onSelectionChange = useRecipientSelection({
    rows: users,
    preSelectedIds,
    selected: selectedUsers,
    setSelected: setSelectedUsers,
  });

  // Debounced search (like UserList example)
  useEffect(() => {
    const timer = setTimeout(() => {
      if ((query.namePattern || "") !== searchTerm) {
        setQuery({ ...query, namePattern: searchTerm, pageNo: 1 });
        fetchUsers?.(searchTerm);
      }
    }, 500);
    return () => clearTimeout(timer);
  }, [searchTerm, fetchUsers, setQuery, query.namePattern]);

  const handlePageChange = (pageData) => {
    if (query.pageSize !== pageData.rows || query.pageNo !== pageData.page + 1) {
      setQuery({ ...query, pageNo: pageData.page + 1, pageSize: pageData.rows });
    }
  };

  return (
    <div>
      <div className="edexlms-search-filter-bar mb-4 flex">
        <TextInput
          icon="pi pi-search"
          placeholder="Search Users"
          input={{ value: searchTerm, onChange: (e) => setSearchTerm(e.target.value) }}
        />
      </div>

      <List
        data={users}
        totalRecords={totalCount}
        pageQuery={query}
        handlePageChange={handlePageChange}
        selectionMode="checkbox"
        selectedRecords={selectedUsers}
        onSelectionChange={onSelectionChange}
        columns={[
          {
            field: "name",
            header: "Name",
            body: (rowData) => (
        <div>
          <div className="font-medium">{rowData.name}</div>
          <div className="text-sm text-gray-500">{rowData.email}</div>
        </div>
      ),
    
          },
          // {
          //   field: "userCount",
          //   header: "User Count",
          //   body: (rowData) => <div>{rowData.userCount ?? 0}</div>,
          // },
        ]}
      />

      <div className="flex justify-end mt-4 gap-2">
        <Button label="Cancel" onClick={onCancel} className="p-button-text" />
        <Button label="Save" onClick={() => onSave(selectedUsers)} />
      </div>
    </div>
  );
};

export default UserList;
